/*
 * ===============================================================================================================
 *                                Copyright 2022, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { FormHelperText, Grid, IconButton, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from '../styles';
import {
    DELETE,
    DISPLAY_NAME,
    ENTITY_ATTRIBUTE_LABEL,
    POLICY_ACTIONS_LABEL,
    SELECT_ALL
} from '../constants';
import { Trash } from '@jda/lui-common-icon-library-mui5';
import { IAttributeProps } from '../../../models/Policies/PolicyContract';
import { compareByProperty } from '../../../utility/commonUtility';
import { SearchableList } from '../../CustomList';
import { CommonFunctions } from './EntityPolicy';
import {
  getAttributesList,
  getColumnAttributes,
  getColumnAttributesFormError
} from '../../../store/role/policyEntity/entitySelector';
import {
  setColumnAttributeFormData,
  setColumnAttributeFormErrorData
} from '../../../store/role/policyEntity/entityActionCreator';
import LuiMultiSelectCustom from '../../../shared/LuiMultiSelectCustom';

const ColumnAttribute = ({ attribute, index, entityName, actions }: IAttributeProps) => {
  const { classes } = useStyles();
  const attributeList = useSelector(getAttributesList);
  const attributesFormError = useSelector(getColumnAttributesFormError);
  const columnAttributes = useSelector(getColumnAttributes);
  const dispatch = useDispatch();
  const loading =
    entityName && entityName !== 'location' ? false : attributeList && attributeList.length > 0 ? false : true;

  let entityAttributes =
    attributeList &&
    attributeList.sort((a: any, b: any) => a.displayName.toUpperCase().localeCompare(b.displayName.toUpperCase()));
console.log('columnAttributes', columnAttributes);
console.log('attributeList', attributeList);
  return (
    <Grid container alignItems="flex-end" justifyContent="space-between">
      <Grid item xs={6} className={classes.formStyle}>
        <SearchableList
          id="autocomplete-search-attribute"
          options={entityAttributes}
          classes={classes}
          value={attribute.attribute || undefined}
          handleChange={
            CommonFunctions(
              columnAttributes,
              attributesFormError,
              setColumnAttributeFormData,
              setColumnAttributeFormErrorData,
              attributeList,
              dispatch,
              index
            ).searchableListSelection
          }
          loading={loading}
          title={ENTITY_ATTRIBUTE_LABEL}
        />
        <FormHelperText
          id={`attribute-helper-text-${index}`}
          error={attributesFormError && attributesFormError.length > 0 && attributesFormError[index].attribute !== ''}
        >
          {attributesFormError && attributesFormError.length > 0 && attributesFormError[index].attribute}
        </FormHelperText>
      </Grid>
      <Grid item xs={4} className={classes.formStyle}>
        <LuiMultiSelectCustom
          id={`attribute-value-action-multi-select-${index}`}
          itemData={actions.sort(compareByProperty(DISPLAY_NAME))}
          itemKey="key"
          itemDisplayName={DISPLAY_NAME}
          inputLabel={POLICY_ACTIONS_LABEL}
          placeHolder={POLICY_ACTIONS_LABEL}
          selectedItems={attribute && attribute.attributeAction}
          selectAll
          selectAllDisplayText={SELECT_ALL}
          onSelectionChange={(e:any) =>
            CommonFunctions(
              columnAttributes,
              attributesFormError,
              setColumnAttributeFormData,
              setColumnAttributeFormErrorData,
              attributeList,
              dispatch,
              index
            ).onSelectionChange('attributeAction', index, { target: { name: '', value: e } })
          }
        />
        <FormHelperText
          id={`attribute-value-action-helper-text-${index}`}
          error={
            attributesFormError && attributesFormError.length > 0 && attributesFormError[index].attributeAction !== ''
          }
        >
          {attributesFormError && attributesFormError.length > 0 && attributesFormError[index].attributeAction}
        </FormHelperText>
      </Grid>
      <Grid item xs={1} className={classes.deleteIcon}>
        <Tooltip id="attribute-icon-button-tooltip" title={DELETE}>
          <IconButton
            id="attribute-icon-button"
            aria-label="delete"
            onClick={() =>
              CommonFunctions(
                columnAttributes,
                attributesFormError,
                setColumnAttributeFormData,
                setColumnAttributeFormErrorData,
                attributeList,
                dispatch,
                index
              ).handleRowDelete(index)
            }
          >
            <Trash />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default ColumnAttribute;
